export const SCKpis = {
  // tslint:disable:object-literal-sort-keys
  SC_BUDGET: "sc_budget",
  SC_BUDGET_SALES: "sc_budget_sales",
  SC_BUDGET_SALES_PRORATA: "sc_budget_sales_prorata",
  SC_BUDGET_PRORATA: "sc_budget_prorata",
  SC_BUDGET_Team: "sc_budget_team",
  SC_BUDGET_Team_PRORATA: "sc_budget_team_prorata",
  SC_BUDGET_PC: "sc_budget_pc",
  SC_BUDGET_PC_PRORATA: "sc_budget_pc_prorata",
  SC_BUDGET_SBU: "sc_budget_sbu",
  SC_BUDGET_SBU_PRORATA: "sc_budget_SBU_prorata",
  SC_BUDGET_BU: "sc_budget_bu",
  SC_BUDGET_BU_PRORATA: "sc_budget_bu_prorata",
  SC_COM_YTD: "sc_com_ytd",
  SC_COM_YTD_1: "sc_com_ytd_1",
  SC_CSA_YTD: "sc_csa_ytd",
  SC_CSA_YTD_1: "sc_csa_ytd_1",
  SC_CVA_FEE_YTD: "sc_cva_fee_ytd",
  SC_CVA_YTD: "sc_cva_fee_ytd",
  SC_CVA_YTD_1: "sc_cva_fee_ytd_1",
  SC_CVA_FEE: "sc_cva_fee",
  SC_CVA_FEE_EURO: "sc_cva_fee_euro",
  SC_DTD: "sc_d_1",
  SC_D_1: "sc_d_1",
  SC_D_2: "sc_d_2",
  SC_F2Y_YTD: "sc_f2y_ytd",
  SC_F2Y_YTD_1: "sc_f2y_ytd_1",
  SC_FEES_YTD: "sc_fees_ytd",
  SC_FEES_YTD_1: "sc_fees_ytd_1",
  SC_MARKUP_YTD: "sc_markup_ytd",
  SC_MARKUP_YTD_1: "sc_markup_ytd_1",
  SC_MTD: "sc_mtd",
  SC_MTD_1: "sc_mtd_1",
  SC_MTD_YOY: "sc_mtd_yoy",
  SC_SC_1: "sc_sc_1",
  SC_SC_2: "sc_sc_2",
  SC_TRADPL_YTD: "sc_tr_pnl_ytd",
  SC_TRADPL_YTD_1: "sc_tr_pnl_ytd_1",
  SC_WTD: "sc_wtd",
  SC_WTD_1: "sc_wtd_1",
  SC_WTD_2: "sc_wtd_2",
  SC_WTD_3: "sc_wtd_3",
  SC_YOICE_YTD: "sc_voice_ytd",
  SC_YOICE_YTD_1: "sc_voice_ytd_1",
  SC_ELEC_YTD: "sc_elec_ytd",
  SC_ELEC_YTD_1: "sc_elec_ytd_1",
  SC_YOY_PER: "sc_yoy_per",
  SC_YTD: "sc_ytd",
  SC_YTD_1: "sc_ytd_1",
  SC_YTD_2: "sc_ytd_2",
  SC_YTD_3: "sc_ytd_3",
  SC_Y_VS_Y1: "sc_y_vs_y1",
  SC_SC: "sc_sc",
  SC_SC_EX: "sc_ex_sc",
  SC_YTD_EX: "sc_ex_ytd",
  SC_YTD_EX_1: "sc_ex_ytd_1",
  SC_COM_YTD_EX: "sc_com_ex_ytd",
  SC_COM_YTD_EX_1: "sc_com_ex_ytd_1",
  SC_CSA_YTD_EX: "sc_csa_ex_ytd",
  SC_CSA_YTD_EX_1: "sc_csa_ex_ytd_1",
  SC_D_EX_1: "sc_ex_d_1",
  SC_D_EX_2: "sc_ex_d_2",
  SC_F2Y: "sc_f2y",
  SC_F2Y_EURO: "sc_f2y_euro",
  SC_MTD_EX: "sc_ex_mtd",
  SC_SC_EX_1: "sc_ex_sc_1",
  SC_SC_EX_2: "sc_ex_sc_2",
  SC_WTD_EX: "sc_ex_wtd",
  SC_WTD_EX_1: "sc_ex_wtd_1",
  SC_WTD_EX_2: "sc_ex_wtd_2",
  SC_WTD_EX_3: "sc_ex_wtd_3",
  SC_YTD_EX_2: "sc_ex_ytd_2",
  SC_YTD_EX_3: "sc_ex_ytd_3",
  SC_FEES_YTD_EX: "sc_feesex_ytd",
  SC_FEES_YTD_EX_1: "sc_feesex_ytd_1",
  SC_MARKUP: "sc_markup",
  SC_MARKUP_EURO: "sc_markup_euro",
  SC_TRADPL_YTD_EX: "sc_tr_pnl_ex_ytd",
  SC_TRADPL_YTD_EX_1: "sc_tr_pnl_ex_ytd_1",
  SC_YOY_PER_EX: "sc_yoy_ex_per",
  SC_Y_VS_Y1_EX: "sc_y_vs_y1_ex",
  SC_AXE_YTD: "sc_axe_ytd",
  SC_RISK_FREE_YTD: "sc_risk_free_ytd",
  SC_ONE_WAY_YTD: "sc_oneway_ytd",
  SC_PURE_MU_YTD: "sc_pure_mu_ytd",
  SC_PRIMARY_YTD: "sc_primary_ytd",
  SC_TWO_WAY_YTD: "sc_two_wy_ytd",
  SC_LOW_NO_RISK: "sc_low_no_risk",
  SC_NOMINAL_AMOUNT: "marksc_nominal",
  SC_NOMINAL_YTD: "nominal_ytd",
  SC_NOMINAL_YTD_EURO: "nominal_ytd_euro",
  SC_NOMINAL_MTD: "nominal_mtd",
  SC_NOMINAL_D_1: "nominal_d_1",
  SC_RECIVED_FEE: "sc_rec_fees_ytd",
  SC_USD: "sc_usd",
  SC_MARK_UP_NET_CVA_S1: "sc_mark_up_net_cva_s1",
  SC_FY: "sc_fy",
  SC_FY_1: "sc_fy_1",
  SC_VOLUMES_YTD: "volumes_ytd",
  SC_VOLUMES_YTD_1: "volumes_ytd_1",
  SC_BUDGET_TEAM: "sc_budget_team",
  SC_MTD_STEP1: "sc_mtd_step1",
  SC_YTD_USD: "sc_ytd_usd",
  SC_YTD_USD_1: "sc_ytd_usd_1",
  SC_SC_USD_1: "sc_sc_usd_1",
  SC_D_USD_1: "sc_d_usd_1",
  SC_D_USD_2: "sc_d_usd_2",
  SC_WTD_USD: "sc_wtd_usd",
  SC_WTD_USD_1: "sc_wtd_usd_1",
  SC_WTD_USD_2: "sc_wtd_usd_2",
  SC_MTD_USD: "sc_mtd_usd",
};
